define(["knockout", "@modules/tools/urlParameters", "querystring"], function (ko, urlParameters, querystring) {
    function cleanupUrl(baseUrl, queryObject) {
        return baseUrl + "?" + querystring.stringify(urlParameters.reduceParams(queryObject, {}));
    }

    function isEnterKey(event) {
        return event.keyCode === 13;
    }

    // HelpfulBlockOverlayViewModel ctor
    return function () {
        var self = this;

        // Provider Functionality
        if (window.scan.helpfulContentBlock.providerLink !== null) {
            self.providerZipCode = ko.observable("");
            self.providerName = ko.observable("");
            self.showSearchByProviderZipCode = ko.observable(true);
            self.providerSearchLink = ko.observable(window.scan.helpfulContentBlock.providerLink);
            self.pathQueryValue = ko.observable(window.scan.helpfulContentBlock.pathQueryValue);

            self.providerSearchUrl = ko.computed(function () {
                var baseUrl = self.providerSearchLink().Url;
                var query = {
                    path: self.pathQueryValue()
                };
                if (self.showSearchByProviderZipCode()) {
                    query.zipOrAddress = self.providerZipCode();
                } else {
                    query.name = self.providerName();
                }

                return cleanupUrl(baseUrl, query);
            }, this);

            self.navigateToProviderSearchOnEnter = function (d, e) {
                if (isEnterKey(e)) {
                    window.location.href = self.providerSearchUrl();
                }
                return true;
            };
        }

        // Formulary Functionality
        if (window.scan.helpfulContentBlock.formularyLink !== null) {
            self.formularyName = ko.observable("");
            self.formularySearchLink = ko.observable(window.scan.helpfulContentBlock.formularyLink);

            self.formularySearchUrl = ko.computed(function () {
                var baseUrl = self.formularySearchLink().Url;
                var query = {
                    path: self.pathQueryValue(),
                    drugName: self.formularyName()
                };
                return cleanupUrl(baseUrl, query);
            }, this);

            self.navigateToFormularySearchOnEnter = function (d, e) {
                if (isEnterKey(e)) {
                    window.location.href = self.formularySearchUrl();
                }
                return true;
            };
        }

        // Plan Functionality
        if (window.scan.helpfulContentBlock.planLink !== null) {
            self.planZipCode = ko.observable("");
            self.planSearchLink = ko.observable(window.scan.helpfulContentBlock.planLink);

            self.planSearchUrl = ko.computed(function () {
                var baseUrl = self.planSearchLink().Url;
                var query = {
                    path: self.pathQueryValue(),
                    zipCode: self.planZipCode()
                };
                return cleanupUrl(baseUrl, query);
            }, this);

            self.navigateToPlanSearchOnEnter = function (d, e) {
                if (isEnterKey(e)) {
                    window.location.href = self.planSearchUrl();
                }
                return true;
            };
        }
    };
});
